import { useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useTheme } from "@mui/material";
import { FinancialGoal } from "@rentablo/api/apiv1";
import { useGoalHistory } from "../../hooks/useGoalHistory";
import { actualSeries, planSeries, todayIso } from "../../utils/goalChartData";
import { seriesColors } from "../chart/goalChartStyle";

/** Vermögen and Plan since the goal's start, without axes */
export const GoalSparkline = ({ goal }: { goal: FinancialGoal }) => {
  const theme = useTheme();
  const { points: history } = useGoalHistory(goal);
  const today = todayIso();

  const options = useMemo((): Highcharts.Options => {
    const colors = seriesColors(theme);
    return {
      credits: { enabled: false },
      title: { text: "" },
      legend: { enabled: false },
      tooltip: { enabled: false },
      chart: {
        height: 67,
        margin: [2, 0, 0, 0],
        spacing: [0, 0, 0, 0],
        backgroundColor: "transparent",
      },
      xAxis: { type: "datetime", visible: false },
      yAxis: { visible: false, startOnTick: false, endOnTick: false },
      plotOptions: {
        series: {
          animation: false,
          enableMouseTracking: false,
          marker: { enabled: false },
          lineWidth: 2,
        },
      },
      series: [
        {
          type: "area",
          data: actualSeries(goal, history, today),
          color: colors.wealth,
          threshold: null,
          fillColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [
                0,
                String(
                  Highcharts.color(colors.wealth).setOpacity(0.2).get("rgba")
                ),
              ],
              [
                1,
                String(
                  Highcharts.color(colors.wealth).setOpacity(0).get("rgba")
                ),
              ],
            ],
          },
        },
        {
          type: "line",
          data: planSeries(goal, today, today),
          color: colors.plan,
          dashStyle: "Dash",
        },
      ],
    };
  }, [goal, history, today, theme]);

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
